<template>
  <div class="car-user-data-form">
    <div class="car-form-item car-form-item-email" :class="{'car-form-item-error': !v.form.email.required && v.form.email.$error}">
      <label for="email">{{$t('customer.email')}}*</label>
      <input type="text"
             id="email"
             data-js="email__input"
             v-model="form.email"
             :class="{ 'car-filled': form.email }"
             v-bind:placeholder="$t('customer.email')+'*'">
      <div class="car-error-message" v-if="!v.form.email.required && v.form.email.$error">
        {{$t('customer.errors.email')}}
      </div>
    </div>
    <div class="car-form-item car-form-item-firstname" :class="{'car-form-item-error': !v.form.firstName.required && v.form.firstName.$error}">
      <label for="first-name">{{$t('customer.firstName')}}*</label>
      <input type="text"
             id="first-name"
             data-js="first-name__input"
             v-model="form.firstName"
             :class="{ 'car-filled': form.firstName}"
             v-bind:placeholder="$t('customer.firstName')+'*'">
      <div class="car-error-message" v-if="!v.form.firstName.required && v.form.firstName.$error">
        {{$t('customer.errors.firstName')}}
      </div>
    </div>
    <div class="car-form-item car-form-item-lastname" :class="{'car-form-item-error': !v.form.lastName.required && v.form.lastName.$error}">
      <label for="last-name">{{$t('customer.lastName')}}*</label>
      <input type="text"
             id="last-name"
             data-js="last-name__input"
             v-model="form.lastName"
             :class="{'car-filled': form.lastName}"
             v-bind:placeholder="$t('customer.lastName')+'*'">
      <div class="car-error-message" v-if="!v.form.lastName.required && v.form.lastName.$error">
        {{$t('customer.errors.lastName')}}
      </div>
    </div>
    <div class="car-form-item car-form-item-phone" :class="{'car-form-item-error': !v.form.phone.required && v.form.phone.$error}">
      <label for="phone">{{$t('customer.phone')}}*</label>
      <input type="text"
             id="phone"
             data-js="phone__input"
             v-model="form.phone"
             :class="{ 'car-filled': form.phone}"
             v-bind:placeholder="$t('customer.phone')+'*'">
      <div class="car-error-message" v-if="!v.form.phone.required && v.form.phone.$error">
        {{$t('customer.errors.phone')}}
      </div>
    </div>
    <div class="car-form-item">
      <label for="mileage">{{$t('customer.mileage')}}</label>
      <input type="text"
             id="mileage"
             data-js="mileage__input"
             v-model="form.mileage"
             :class="{ 'car-filled': form.mileage }"
             v-bind:placeholder="$t('customer.mileage')">
    </div>
    <div class="car-form-item car-form-item-vin">
      <label for="vin">{{$t('customer.vin')}}</label>
      <input type="text"
             id="vin"
             data-js="vin__input"
             v-model="form.vin"
             :class="{ 'car-filled': form.vin }"
             v-bind:placeholder="$t('customer.vin')">
    </div>
    <div class="car-form-item car-form-item-comment">
      <label for="message">{{ $t('customer.comment') }}</label>
      <textarea type="text"
                rows="3"
                id="message"
                data-js="message__input"
                v-model="form.comment"
                :class="{'car-option--selected': form.comment}"
                v-bind:placeholder="$t('customer.comment')" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Customer',
  props: {
    form: {
      default: {}
    },
    v: {
      default: {}
    }
  }
};
</script>
